import React, { useState } from 'react';
import classes from './Header.module.scss';
import moobitekLogo from '../../assets/MoobitekLogos/MoobitekFinalLogowhite.png';
import homePageIcon from '../../assets/menuIcons/homePage.svg';
import lotteryStudio from '../../assets/menuIcons/lotteryStudio.svg';
import scratchGame from '../../assets/menuIcons/scratchGame.svg';
import sportsBetting from '../../assets/menuIcons/sportsBetting.svg';
import poolBetting from '../../assets/menuIcons/poolBetting.svg';
import moobitekIcon from '../../assets/menuIcons/moobitekIcon.svg';
import { Link } from 'react-router-dom';

function Header({ changeColor }) {
    const [btnstate, setbtnstate] = useState("");
    const [menulist, setmenulist] = useState("hidden");
    const [mobilemenu, setmobilemenu] = useState("closed");


    const openmenu = () => {
        if (mobilemenu === "closed") {
            setmobilemenu("open");
            setbtnstate("open");
            setmenulist("visible");
        } else {
            setmobilemenu("closed");
            setbtnstate("closed");
            setmenulist("hidden");
        }
    };


    return (
        <header className={`${classes.header} ${classes[changeColor]}`}>
            <div className="container">
                <div className={classes.topHeader}>
                    <Link to="/" className={classes.logoMobile}>
                        <img
                            src={moobitekLogo}
                            alt="moobitek Logo "
                            className={classes.logo}
                        />
                    </Link>
                    <div className={classes.burgermenuContainer} onClick={openmenu}>
                        <i
                            className={`${btnstate === "open" ? classes.openbtn : classes.closebtn
                                }`}
                        ></i>
                        <i
                            className={`${btnstate === "open" ? classes.openbtn : classes.closebtn
                                }`}
                        ></i>
                        <i
                            className={`${btnstate === "open" ? classes.openbtn : classes.closebtn
                                }`}
                        ></i>
                    </div>
                    <nav className={`${classes.menulist} ${menulist === "visible" ? classes.open : classes.close}`}>
                        <ul className={classes.ul_list}>
                            <li className={classes.navigateTabs}>
                                <Link to="/" style={{ textDecoration: "none" }}>
                                    <div className={classes.insideInfo}>
                                        <span className={classes.iconText}>HOMEPAGE</span>
                                        <img src={homePageIcon} alt="menu icon" className={classes.menuIconsStyle} />
                                    </div>
                                </Link>
                            </li>
                            <li className={classes.navigateTabs}>
                                <Link to="/lotteryGames" style={{ textDecoration: "none" }}>
                                    <div className={classes.insideInfo}>
                                        <span className={classes.iconText}>LOTTERY STUDIO</span>
                                        <img src={lotteryStudio} alt="menu icon" className={classes.menuIconsStyle} />
                                    </div>
                                </Link>
                            </li>
                            <li className={classes.navigateTabs}>
                                <Link to="/scratchGames" style={{ textDecoration: "none" }}>
                                    <div className={classes.insideInfo}>
                                        <span className={classes.iconText}>SCRATCH & CHANCE</span>
                                        <img src={scratchGame} alt="menu icon" className={classes.menuIconsStyle + " " + classes.iconTextScratch} />
                                    </div>
                                </Link>
                            </li>
                            <li className={classes.navigateTabs}>
                                <Link to="/sportsbetting" style={{ textDecoration: "none" }}>
                                    <div className={classes.insideInfo}>
                                        <span className={classes.iconText}>SPORTS BETTING</span>
                                        <img src={sportsBetting} alt="menu icon" className={classes.menuIconsStyle + " " + classes.iconTextScratch} />
                                    </div>
                                </Link>
                            </li>
                            <li className={classes.navigateTabs}>
                                <Link to="/footycash" style={{ textDecoration: "none" }} >
                                    <div className={classes.insideInfo}>
                                        <span className={classes.iconText}>POOL BETTING</span>
                                        <img src={poolBetting} alt="menu icon" className={classes.menuIconsStyle + " " + classes.iconTextScratch} />
                                    </div>
                                </Link>
                            </li>
                            <li className={classes.navigateTabs}>
                                <a href="https://www.moobitek.com/" target="_blank" rel="noopener noreferrer" className={classes.navigateTabs}>
                                    <div className={classes.insideInfo}>
                                        <span className={classes.iconText + " " + classes.secondtext}>www.moobitek.com</span>
                                        <img src={moobitekIcon} alt="menu icon" className={classes.menuIconsStyle} />
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    )
}

export default Header;
